import React, {useState, useEffect} from "react";
import PropTypes from "prop-types";
import {ExpandLess, ExpandMore, LockOutlined} from "@mui/icons-material";
import {
  Box,
  Collapse,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import {makeStyles} from "tss-react/mui";
import {isUndefined} from "underscore";

const useCollapsibleStyles = makeStyles()((theme, {margin, noPrint}) => ({
  collapse: {
    border: "1px solid",
    borderColor: theme.palette.grey.light,
    "@media print": {
      display: noPrint ? "none" : undefined,
    },
  },
  collapsibleBox: {
    marginTop: margin?.top ? theme.spacing(margin.top) : undefined,
    marginBottom: margin?.bottom ? theme.spacing(margin.bottom) : undefined,
    marginLeft: margin?.left ? theme.spacing(margin.left) : undefined,
    marginRight: margin?.right ? theme.spacing(margin.right) : undefined,
  },
  iconWrapper: {
    "@media print": {
      display: "none",
    },
  },
}));

const Collapsible = ({
  children,
  expanded = false,
  forceOpen = false,
  hidden = false,
  icon,
  margin = {},
  onClick,
  noPrint = false,
  title = "Open",
}) => {
  if (!children) {
    return null;
  }
  const [open, setOpen] = useState(expanded);
  const {classes} = useCollapsibleStyles({margin, noPrint});

  const handleOpen = () => {
    onClick && onClick();
    if (forceOpen) {
      return;
    }
    setOpen((isOpen) => !isOpen);
  };

  useEffect(() => {
    setOpen(expanded);
  }, [expanded]);

  return (
    <Box
      id="collapsible"
      width="100%"
      className={classes.collapsibleBox}
      hidden={hidden}
    >
      <ListItemButton onClick={handleOpen} className={classes.collapse}>
        {!isUndefined(icon) && (
          <ListItemIcon sx={{minWidth: "auto", mr: 1}}>{icon}</ListItemIcon>
        )}
        <ListItemText primary={title} sx={{span: {fontWeight: 500}}} />
        <span className={classes.iconWrapper}>
          {forceOpen ?
            <LockOutlined /> :
            open ?
              <ExpandLess /> :
              <ExpandMore />}
        </span>
      </ListItemButton>
      <Collapse
        in={open || forceOpen}
        timeout="auto"
        unmountOnExit
        className={classes.collapse}
      >
        <Box ml={1} mr={1} pb={1}>
          {children}
        </Box>
      </Collapse>
    </Box>
  );
};

Collapsible.propTypes = {
  children: PropTypes.any.isRequired,
  expanded: PropTypes.bool,
  forceOpen: PropTypes.bool,
  hidden: PropTypes.bool,
  icon: PropTypes.any,
  onClick: PropTypes.func,
  margin: PropTypes.any,
  noPrint: PropTypes.bool,
  title: PropTypes.string,
};

export default Collapsible;
